export default "__VITE_ASSET__e72c442f__"